export const setupPasswordResourcePath = "/setup_password";
export const setupPasswordResourceType = "setup_password";
